<style lang="less" scoped>
@import '../../../style/common/variable';
.newsKYZX {position: relative;overflow: hidden;font-family: AlibabaPuHuiTi-Regular;
ul{list-style:none;margin:0px;padding:0px 10px;}
li {position: relative;display: block;margin:0px;padding:0px;overflow: hidden;cursor: pointer;}
li:hover {background: #f5f7fa}
div, p {margin:0px;padding:0px;}
.titleFirst {font-size: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #333;height: 40px;line-height: 40px;}
.box {position: absolute;overflow: hidden;height: 0;top: 0;left: 0;transition: height 0.6s;background: rgb(245, 243, 243);}
.picBox {float: left;width: 100px;height: 60px;overflow: hidden;border: 1px solid #eee;}
img {border: none;vertical-align: top;width: 100px;height: 60px;transition: transform .5s;}
img:hover {transform: scale(1.4,1.2)}
.textBox {float: left;margin-top: -60px;margin-left: 110px;}
.title {overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-size: 14px;color: #333;}
.title:hover {color: #13569e;}
.content {font-size: 12px;color: rgb(73, 73, 73);overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;margin-top: 5px;}
.content{height: 32px;line-height: 16px; overflow:hidden;}
.content::after{content: ' ... ';}
li:nth-child(1) {height: 65px;}
li:nth-child(1) .box {height: 65px;}
li:hover {height: 65px;}
li:hover .box {height: 65px;}}
@media screen and (max-width: @max-screen){
  .newsKYZX{width: 100vw !important; height: 3.25rem !important;
    img{transform: none !important;}
    li{display: flex;justify-content: flex-start; height: .65rem !important;
      .box{height: .65rem!important;}
    }
    .box{width: 100vw;display: flex;justify-content: center;}
    .picBox{width: 34vw !important;}
    .textBox{width: 58vw !important;float: none;margin-top: 0px;margin-left: 0px;
      .title{width: 58vw !important;}
      .content{width: 58vw !important;}
    }
  }
}
</style>

<!--何宽 2021.6.12
    该卡片组件使用场景：以列表的形式纵向展示各条新闻的标题，当鼠标移入某条新闻的时候，该新闻展开图片、标题及内容（默认第一条展开）
    鼠标移入新闻的图片上时，图片会放大，
    鼠标点击新闻的图片、标题或内容，将 整个新闻的对象 传递给父组件 -->
<template>
  <div class="newsKYZX" :style="{width:widthCSH+'px',height:heightCSH+'px'}">
    <ul>
      <li v-for="(item,index) in newsKYZXList" :key="index" @click="clickNewsKyzx(item)">
        <p class="titleFirst"> {{ item.title }} </p>
        <div class="box">
          <div class="picBox">
            <img :src="item.pic">
          </div>
          <div class="textBox" :style="{width:0.6 * widthCSH+'px'}">
            <p class="title" :style="{width:0.5 * widthCSH+'px'}"> {{ item.title }} </p>
            <p class="content" :style="{width:0.5 * widthCSH+'px'}"> {{ item.introduce }} </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  props: ['widthCSH', 'heightCSH', 'newsKYZXList'],
  data()
  {
    return {}
  },
  updated()
  {
    $('.newsKYZX ul li:nth-child(n+2)').mouseover(function()
    {
      $('.newsKYZX ul li:nth-child(1)').css('height', '40px')
      $('.newsKYZX ul li:nth-child(1) .box').css('height', '0')
    })
    $('.newsKYZX ul li:nth-child(n+2)').mouseleave(function()
    {
      $('.newsKYZX ul li:nth-child(1)').css('height', '65px')
      $('.newsKYZX ul li:nth-child(1) .box').css('height', '65px')
    })
    var oList = document.querySelectorAll('.content')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'content'
    })
  },
  methods: {
    // 点击 新闻图片、名称或内容，将 整个新闻对象 传递给父组件
    clickNewsKyzx(item)
    {
      this.$emit('clickNewsKyzx', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/NewsKYZX.vue